document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.faq-question').forEach(function(button) {
      button.addEventListener('click', function() {
        var item = button.parentElement;
  
        document.querySelectorAll('.faq-item.active').forEach(function(activeItem) {
          if (activeItem !== item) {
            activeItem.classList.remove('active');
          }
        });
  
        item.classList.toggle('active');
      });
    });
  });